import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotesState } from 'src/app/recruiting/candidates/new-profile/notes-and-activities/store/notes.state';

export const notesFeatureKey = 'notes';
export const notesFeature = createFeatureSelector<NotesState>(notesFeatureKey);

export const selectLoading = createSelector(notesFeature, (state) => state.loading);
export const selectNotesAndActivities = createSelector(notesFeature, (state) => state.notesAndActivities);
export const selectOrientationNotes = createSelector(notesFeature, (state) => state.orientationNotes);

export const selectAddingNote = createSelector(notesFeature, (state) => state.addingNote);
export const selectCandidateId = createSelector(notesFeature, (state) => state.candidateId);
export const selectLimitHistory = createSelector(notesFeature, (state) => state.limitHistory);
